import { useQuery } from "@apollo/client";
import { getBookletNameQuery } from "../../queries/booklet";


interface BookletTitleProps {
    bookletId: string;
}

/**
 * Helper component to fetch booklet title when needed
 * @param bookletId
 * @returns booklet title
 */
export function BookletTitle({ bookletId }: BookletTitleProps) {
    const { data, loading, error } = useQuery(getBookletNameQuery, {
        variables: { _id: bookletId },
        fetchPolicy: 'cache-first'
    });

    if (loading) return <>Loading...</>;
    if (error) return <>Error loading title</>;

    return <>{data?.booklet?.title || bookletId}</>;
}
